export const getValidDescription = (description: string = ""): string => {
  const trimmedDescription = description
    .trim()
    .replace(/undefined/g, "Transaction");
  return trimmedDescription === "" ? "Transaction" : trimmedDescription;
};
